const API_URL_BASE = 'https://calcadmin.fullmerco.com/api/v1';
const API_TOKEN =
  'FuPrX6NQmAMxUiQDsSeET1mf6oW60ubcqGQZ8chM4PYxXA2nqg3z3jobYdkScAethITitorXdN3epNFA';

export { API_URL_BASE, API_TOKEN };
